"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolutionsInUseManager = void 0;
const mobx_1 = require("mobx");
const log_client_1 = require("@video/log-client");
const video_client_core_1 = require("@video/video-client-core");
class ResolutionsInUseManager extends video_client_core_1.ObservableEventEmitter {
    get devicesInUseSize() {
        return this.devicesInUse.size;
    }
    constructor(options) {
        super();
        this.devicesInUse = mobx_1.observable.map();
        (0, video_client_core_1.makeBounded)(this);
        this.mediaStreamController = options.msc;
        this.logger = new log_client_1.LoggerCore("VDC-core").setLoggerMeta("client", "VDC").appendChain(ResolutionsInUseManager);
        this.logger.info("constructor()", options);
        this.mediaStreamController.on("videoDeviceChanged", this.checkResolutionsInUse);
        this.mediaStreamController.on("disposed", () => this.dispose("MediaStreamController disposed"));
        (0, mobx_1.makeObservable)(this, {
            // observables
            devicesInUse: mobx_1.observable.deep,
            mediaStreamController: mobx_1.observable.ref,
            // computed
            currentAvailableResolutions: mobx_1.computed,
            devicesInUseSize: mobx_1.computed,
            // action
            addDeviceInUse: mobx_1.action,
        });
        this.addInnerDisposer(() => this.mediaStreamController.off("videoDeviceChanged", this.checkResolutionsInUse));
        this.addInnerDisposer((0, mobx_1.autorun)(() => {
            if (this.devicesInUse.size === 0 || this.devicesInUse.size === 1) {
                this.mediaStreamController.off("videoDeviceChanged", this.checkResolutionsInUse);
            }
            if (this.devicesInUse.size === 1) {
                this.mediaStreamController.on("videoDeviceChanged", this.checkResolutionsInUse);
            }
        }));
    }
    addDeviceInUse(event) {
        // check if this device is already in our map
        if ((0, mobx_1.has)(this.devicesInUse, event.videoDevice.deviceId) === false) {
            this.logger.info("adding new deviceInUse", event);
            (0, mobx_1.set)(this.devicesInUse, { [event.videoDevice.deviceId]: event });
        }
    }
    get currentAvailableResolutions() {
        var _a;
        if (((_a = this.mediaStreamController) === null || _a === void 0 ? void 0 : _a.videoDeviceId) != null) {
            const deviceInUse = (0, mobx_1.get)(this.devicesInUse, this.mediaStreamController.videoDeviceId);
            return deviceInUse ? deviceInUse.currentAvailableResolutions : null;
        }
        return null;
    }
    async checkResolutionsInUse(videoDevice) {
        this.logger.debug("checkResolutionsInUse()", { videoDevice });
        if (videoDevice == null)
            return;
        const deviceInUse = (0, mobx_1.get)(this.devicesInUse, videoDevice.deviceId);
        // check if the active video device is in our deviceInUse array
        if (deviceInUse == null)
            return;
        try {
            // check if all resolutions are now available
            const { resolutionsInUse } = await this.mediaStreamController.getDeviceResolutions({
                videoDevice,
                deviceInUse: true,
            });
            // only comparable available resolutions with ACTIVE videoDeviceId (otherwise this doesn't work)
            if (!resolutionsInUse) {
                // remove from devicesInUse Array
                (0, mobx_1.remove)(this.devicesInUse, videoDevice.deviceId);
                this.logger.debug("device no longer in use", videoDevice);
                this.emit("deviceAvailable", { videoDevice, available: true });
            }
        }
        catch (err) {
            // do nothing
        }
    }
}
exports.ResolutionsInUseManager = ResolutionsInUseManager;
ResolutionsInUseManager.displayName = "ResolutionsInUse";
//# sourceMappingURL=resolutions-in-use-manager.js.map